<template>
  <div class="row">
    <div class="col-md-6 col-12" v-for="(picture, index) in pictures" :key="index">
      <b-card no-body class="overflow-hidden">
        <b-row no-gutters align-v="center">
          <b-col cols="1">
            <b-card-img
              left
              width="50px"
              height="70px"
              :src="picture.preview.url"
              :alt="getPictureCodeAndName(picture)"
              @click="showDownloadableEfile(picture)"
            ></b-card-img>
          </b-col>
          <b-col cols="10">
            <b-card-body>
              <b-card-text>
                <h5>{{ getPictureCodeAndName(picture) }}</h5>
                <p>{{ getPictureAuthor(picture) }}</p>
              </b-card-text>
              <b-button-toolbar>
                <b-button-group>
                  <b-button variant="outline-default" @click="showInfo(picture)">{{ $t('picture.button.introduction.label') }}</b-button>
                </b-button-group>
                <b-button-group>
                  <b-button
                    variant="primary"
                    @click="addPictureToApplicationList(picture)"
                    :disabled="picture.in_stock == 'N'"
                    v-if="applicable"
                  >{{ picture.in_stock == 'N' ? $t('picture.button.application.label.out-of-stock') : $t('picture.button.application.label.in-stock') }}</b-button>
                  <b-button
                    variant="info"
                    @click="showDownloadList(picture)"
                    v-if="downloadable"
                  >{{ $t('picture.button.download.label') }}</b-button>
                </b-button-group>
              </b-button-toolbar>
            </b-card-body>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <dharma-application-form ref="application_form" v-if="applicable"></dharma-application-form>
    <image-modal :id="`picture-downloadable-efile-modal-${uuid}`" :image="picture_downloadable_efile"></image-modal>
    <b-modal id="info" :title="$t('picture.detail.title')" scrollable centered>
      <picture-info :picture="picture"></picture-info>
      <b-button-toolbar v-if="picture">
        <b-button-group>
          <b-button
            variant="primary"
            :disabled="picture && picture.in_stock === 'N'"
            @click="addPictureToApplicationList(picture)"
            v-if="applicable"
          >{{ picture && picture.in_stock === 'N' ? $t('picture.button.application.label.out-of-stock') : $t('picture.button.application.label.in-stock') }}</b-button>
          <b-button
            variant="info"
            @click="showDownloadList(picture)"
            v-if="downloadable"
          >{{ $t('picture.button.download.label') }}</b-button>
        </b-button-group>
      </b-button-toolbar>
      <template #modal-footer="{ close }">
        <b-button class="w-100" variant="default" @click="close()">{{ $t('modal.button.close.label') }}</b-button>
      </template>
    </b-modal>
    <efile-list-modal :id="`picture-efile-list-modal-${uuid}`" :title="$t('picture.efile-list.title')" v-if="downloadable">
      <template #efile-list>
        <picture-efile-list
          :downloadable_efile="picture_downloadable_efile"
          :printable_efile="picture_printable_efile"
        ></picture-efile-list>
      </template>
    </efile-list-modal>
    <dharma-grant-susp-msg-modal id="dharma-grant-susp-msg-modal"></dharma-grant-susp-msg-modal>
  </div>
</template>

<script>
import Vue from 'vue'

import { ButtonGroupPlugin } from 'bootstrap-vue'
import { ButtonToolbarPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from 'bootstrap-vue'
import { CardPlugin } from 'bootstrap-vue'
import { ImagePlugin } from 'bootstrap-vue'
import { LayoutPlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'

import ApplicationList from '@/components/forms/dharma-application-form/ApplicationList'
import DharmaApplicationForm from '@/components/forms/dharma-application-form/DharmaApplicationForm'
import PictureInfo from '@/components/info/PictureInfo'
import PictureEfileList from '@/components/lists/PictureEfileList'
import EfileListModal from '@/components/modals/EfileListModal.vue'
import ImageModal from '@/components/modals/ImageModal'
import DharmaGrantSuspMsgModal from '@/components/modals/DharmaGrantSuspMsgModal'

import i18n from '@/plugins/i18n.js'

import PictureApiService from '@/services/budaedu-api-services/picture-api-service.js'

Vue.use(ButtonGroupPlugin)
Vue.use(ButtonToolbarPlugin)
Vue.use(ButtonPlugin)
Vue.use(CardPlugin)
Vue.use(ImagePlugin)
Vue.use(LayoutPlugin)
Vue.use(ModalPlugin)

Vue.use(ApplicationList)

Vue.use(PictureApiService)

export default {
  i18n,
  name: 'picture-card-list',
  props: {
    pictures: {
      type: Array,
      required: true
    },
    applicable: {
      type: Boolean,
      default: true
    },
    downloadable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      picture: null,
      picture_downloadable_efile: null,
      picture_printable_efile: null
    }
  },
  methods: {
    addPictureToApplicationList(picture) {
      this.$dharmaApplicationList.addItem({
        code: picture.code,
        name: picture.chinese_name,
        type: picture.type,
        quantity: picture.quantity,
        apply_type: 'picture'
      })
      
      this.$bvModal.show(`application-success-message-${this.$refs[`application_form`].uuid}`)

      // this.showDharmaGrantSuspensionMessage()
    },
    showDharmaGrantSuspensionMessage() {
      this.$bvModal.show('dharma-grant-susp-msg-modal')
    },
    async showDownloadableEfile(picture) {
      this.picture_downloadable_efile = await this.$pictureApiService.getDownloadableEfile(picture)
      this.$bvModal.show(`picture-downloadable-efile-modal-${this.uuid}`)
    },
    showInfo(picture) {
      this.picture = picture
      this.$bvModal.show('info')
    },
    async showDownloadList(picture) {
      this.picture_downloadable_efile = await this.$pictureApiService.getDownloadableEfile(picture)
      this.picture_printable_efile = await this.$pictureApiService.getPrintableEfile(picture)
      this.$bvModal.show(`picture-efile-list-modal-${this.uuid}`)
    },
    getPictureCodeAndName(picture) {
      return `${picture.code} ${this.getPictureName(picture)}`
    },
    getPictureName(picture) {
      return this.$i18n.locale === 'tw' || !picture.english_name
        ? picture.chinese_name
        : picture.english_name
    },
    getPictureAuthor(picture) {
      return this.$i18n.locale === 'tw' || !picture.english_author
        ? picture.chinese_author
        : picture.english_author
    },
  },
  created() {
    // 
  },
  components: {
    DharmaApplicationForm,
    EfileListModal,
    DharmaGrantSuspMsgModal,
    ImageModal,
    PictureEfileList,
    PictureInfo
  }  
}
</script>